// FIX 2026-09-15: en /cart el carrito lateral convive con la propia pagina del
// carrito. Si al cambiar cantidades solo se refresca el panel, la pagina de
// debajo se queda con las cantidades, el total y el aviso de envio viejos, y el
// cliente ve dos cifras distintas a la vez. Devolvemos las secciones del
// template del carrito que esten presentes para refrescarlas tambien.
function seccionesDeLaPaginaDelCarrito(formato) {
  const encontradas = [];
  document.querySelectorAll('[id^="shopify-section-"]').forEach((el) => {
    const id = el.id.replace('shopify-section-', '');
    if (!/(^|_|-)cart-(items|footer)$/.test(id)) return;
    if (formato === 'seccion') {
      // Lo que espera CartItems: id del elemento, seccion a pedir y selector.
      encontradas.push({ id: el.id, section: id, selector: '#' + el.id });
    } else {
      encontradas.push({ id: id, selector: '#' + el.id });
    }
  });
  return encontradas;
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.boundClose = this.close.bind(this);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.boundClose);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Evitar abrir múltiples veces
    if (this.isOpen) return;
    this.isOpen = true;

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      // Disparar evento personalizado para que otros componentes sepan que el drawer se abrió
      document.dispatchEvent(new CustomEvent('cart:drawer-opened'));
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.isOpen = false;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      // Re-bindear el evento del overlay después de actualizar el contenido
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.boundClose);
        overlay.addEventListener('click', this.boundClose);
      }

      // Solo abrir si no está ya abierto
      if (!this.isOpen) {
        this.open();
      } else {
        // Si ya está abierto, solo re-aplicar trapFocus después de actualizar contenido
        removeTrapFocus();
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }

        // Asegurar que overflow-hidden sigue aplicado
        document.body.classList.add('overflow-hidden');
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const secciones = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];

    secciones.push(...seccionesDeLaPaginaDelCarrito('selector'));
    return secciones;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const secciones = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
    // Si estamos en /cart, refrescar tambien la pagina que hay debajo.
    secciones.push(...seccionesDeLaPaginaDelCarrito('seccion'));
    return secciones;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/*
  Bloqueo del fondo con el carrito flotante o la ventanita «¡Añadido al carrito!» abiertos (R3, 11-oct; Francisco 19:18Z:
  «a veces, al hacer scroll, no se mueve el carrito, solo lo de abajo»).
  - Causa: la clase overflow-hidden del body la ponen y la quitan el cajón y la ventanita por separado (la ventanita cierra el
    cajón, y el cierre del cajón la quita aunque la ventanita siga abierta, o al revés): según el orden, el fondo queda suelto.
    Además, en Safari del iPhone overflow: hidden en el body no impide arrastrar la página, y la regla del tema
    (body.overflow-hidden con position: fixed y sin top) sube la página al principio y pierde dónde estaba el cliente.
  - Arreglo: un único bloqueo que mira el ESTADO (cajón abierto o ventanita [open]), no quién lo pidió: body fijo EN SU
    POSICIÓN (position: fixed con top = -scroll) mientras haya alguno abierto, y al cerrarse el último, vuelta exacta a la
    misma posición. La posición se toma de la última vez que la página se movió suelta, porque cuando el tema pone
    overflow-hidden la página ya está arriba (scrollY vale 0). La lista del carrito retiene su scroll (overscroll-behavior: contain).
*/
(() => {
  if (window.__rbmwBloqueoFondo) return;
  window.__rbmwBloqueoFondo = true;
  const estilo = document.createElement('style');
  estilo.textContent =
    'cart-drawer-items, cart-drawer .drawer__inner, .cart-upsell-modal__content{overscroll-behavior:contain;-webkit-overflow-scrolling:touch}' +
    'body.rbmw-fondo-fijo{position:fixed;left:0;right:0;width:100%;overflow:hidden}';
  document.head.appendChild(estilo);
  let fijo = false;
  let y = 0;
  let ultimaY = window.scrollY || window.pageYOffset || 0;
  const temaFijo = () => document.body.classList.contains('overflow-hidden');
  window.addEventListener(
    'scroll',
    () => {
      if (!fijo && !temaFijo()) ultimaY = window.scrollY || window.pageYOffset || 0;
    },
    { passive: true }
  );
  const abierto = () => {
    const cajon = document.querySelector('cart-drawer');
    if (cajon && (cajon.isOpen || cajon.classList.contains('active'))) return true;
    return !!document.querySelector('cart-upsell-modal[open], .cart-upsell-modal[open]');
  };
  const aplicar = () => {
    const ahora = abierto();
    if (ahora && !fijo) {
      y = temaFijo() ? ultimaY : window.scrollY || window.pageYOffset || 0;
      document.body.style.top = `-${y}px`;
      document.body.classList.add('rbmw-fondo-fijo');
      fijo = true;
    } else if (!ahora && fijo) {
      document.body.classList.remove('rbmw-fondo-fijo');
      document.body.style.top = '';
      fijo = false;
      const html = document.documentElement;
      const antes = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      html.style.scrollBehavior = antes;
      ultimaY = y;
    }
  };
  const vigilar = () => {
    // Sin esperar a un fotograma: el tema fija el body en el mismo momento en que abre, y así no llega a pintarse arriba
    const mo = new MutationObserver(aplicar);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('cart-drawer, cart-upsell-modal, .cart-upsell-modal').forEach((el) =>
      mo.observe(el, { attributes: true, attributeFilter: ['class', 'open'] })
    );
    aplicar();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilar);
  else vigilar();
})();
